import TopHead from "./components/top_head";
import Navbar from "./components/top_nav";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Down_nav from "./components/bottom_nav";
import AbstractPage from "./pages/abstract";
import IntroductionPage from "./pages/intro";

import SAMPage from "./pages/SAM";
import RADPage from "./pages/RAD";
import ConclusionPage from "./pages/conclusion";
import AcknowledgementPage from "./pages/acknowledgement";
import ReferencesPage from "./pages/references";
import CitePage from "./pages/cite";

function App() {
  return (
    <div
      style={{
        backgroundImage: 'url("images/r6.jpg")',
        backgroundSize: "cover",
      }}
    >
      <Router basename="/energy/paper/Energy_Seaweeds">
        <TopHead />
        <Navbar />
        <Down_nav />
        <Routes>
          <Route path="/" element={<AbstractPage />} />
          <Route path="/abstract" element={<AbstractPage />} />
          <Route path="/intro" element={<IntroductionPage />} />

          <Route path="/SAM" element={<SAMPage />} />
          <Route path="/RAD" element={<RADPage />} />

          <Route path="/conclusion" element={<ConclusionPage />} />
          <Route path="/acknowledgement" element={<AcknowledgementPage />} />
          <Route path="/references" element={<ReferencesPage />} />
          <Route path="/cite" element={<CitePage />} />
        </Routes>
      </Router>
    </div>
  );
}
export default App;
